import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
    icon: {
        width: 24,
        height: 24
    }
}));
